"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppSettings_1 = __importDefault(require("../AppSettings/AppSettings"));
var IFrameBuilder = /** @class */ (function () {
    function IFrameBuilder() {
    }
    IFrameBuilder.prototype.build = function (config) {
        this._config = config;
        this.create()
            .setWidth(this._config.width)
            .setHeight(this._config.height)
            .setId(this._config.id)
            .setSrc(this.composeIframeUrl(this._config))
            .setAttribute("allowfullscreen", "true")
            .setAttribute("allow", "autoplay")
            .setAttribute("loading", "lazy")
            .setAttribute("title", "B+ widget");
        return this._iframe;
    };
    /**
     * Compose iframe URL
     * @param config
     */
    IFrameBuilder.prototype.composeIframeUrl = function (config) {
        //let iframeURL = AppSettings.IFRAME_BASE_URL() + config.type + ".html?";
        var iframeURL = AppSettings_1.default.IFRAME_BASE_URL() + "index.html?";
        iframeURL += "&width=" + config.width;
        iframeURL += "&height=" + config.height;
        iframeURL += "&id=" + config.id;
        iframeURL += "&type=" + config.type;
        iframeURL += "&appid=" + config.appid;
        iframeURL += "&lang=" + config.lang;
        iframeURL += "&source=" + document.location.href;
        config.attributes.forEach(function (value, key) {
            iframeURL += "&" + key + "=" + value;
        });
        return iframeURL;
    };
    IFrameBuilder.prototype.create = function () {
        this._iframe = document.createElement("iframe");
        this._iframe.classList.add("bp-frame");
        this._iframe.classList.add("bp-frame-" + this._config.type);
        this._iframe.style.border = "0";
        this._iframe.style.overflow = "hidden";
        this._iframe.scrolling = "no";
        return this;
    };
    IFrameBuilder.prototype.setId = function (id) {
        this._iframe.id = id;
        return this;
    };
    IFrameBuilder.prototype.setSrc = function (url) {
        this._iframe.src = url;
        return this;
    };
    IFrameBuilder.prototype.setWidth = function (width) {
        this._iframe.width = width;
        return this;
    };
    IFrameBuilder.prototype.setHeight = function (height) {
        this._iframe.height = height;
        return this;
    };
    IFrameBuilder.prototype.setCss = function (css) {
        this._iframe.className = css;
        return this;
    };
    IFrameBuilder.prototype.setOnLoad = function (callback) {
        this._iframe.addEventListener("load", function (e) {
            callback(e);
        });
        return this;
    };
    IFrameBuilder.prototype.setAttribute = function (name, value) {
        this._iframe.setAttribute(name, value);
        return this;
    };
    return IFrameBuilder;
}());
exports.default = IFrameBuilder;
